export const messages = {
  en: {
    addItemReleaseView: {
      title: 'Apply for Release',
      releaseType: 'Release Type',
      requiredSelectReleaseType: 'Required, please select release type',
      applyCompany: 'Application Company',
      requiredApplyCompany: 'Required, please fill in application company',
      applyPerson: 'Applicant',
      requiredApplyPerson: 'Required, please fill in applicant',
      idCard: 'ID Card',
      requiredIdCard: 'Required, please fill in ID card',
      phone: 'Phone',
      requiredPhone: 'Required, please fill in phone',
      passTime: 'Pass Time',
      requiredPassTime: 'Required, please fill in pass time',
      carNum: 'License Plate',
      optionalCarNum: 'Optional, please fill in license plate',
      remark: 'Remark',
      optionalRemark: 'Optional, please fill in remark',
      releaseItems: 'Release Items',
      addItem: 'Add Item',
      itemName: 'Item Name',
      requiredItemName: 'Required, please fill in item name',
      itemAmount: 'Item Amount',
      requiredItemAmount: 'Required, please fill in amount',
      approverInfo: 'Approver Information',
      approver: 'Approver',
      requiredApprover: 'Required, please select approver',
      validate: {
        releaseType: 'Release type cannot be empty',
        applyCompany: 'Application company cannot be empty',
        applyPerson: 'Applicant cannot be empty',
        idCard: 'ID card cannot be empty',
        phone: 'Phone cannot be empty',
        passTime: 'Pass time cannot be empty',
        itemsRequired: 'At least one item is required',
        itemInfoRequired: 'Item name and amount are required',
        approverRequired: 'Approver is required'
      }
    },
  },
  zh: {
    addItemReleaseView: {
      title: '申请放行',
      releaseType: '放行类型',
      requiredSelectReleaseType: '必填，请选择放行类型',
      applyCompany: '申请单位',
      requiredApplyCompany: '必填，请填写申请单位',
      applyPerson: '申请人',
      requiredApplyPerson: '必填，请填写申请人',
      idCard: '身份证',
      requiredIdCard: '必填，请填写身份证',
      phone: '手机号',
      requiredPhone: '必填，请填写手机号',
      passTime: '通行时间',
      requiredPassTime: '必填，请填写通行时间',
      carNum: '车牌号',
      optionalCarNum: '选填，请填写车牌号',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      releaseItems: '放行物品',
      addItem: '添加物品',
      itemName: '物品名称',
      requiredItemName: '必填，请填写物品名称',
      itemAmount: '物品数量',
      requiredItemAmount: '必填，请填写数量',
      approverInfo: '审批人信息',
      approver: '审批人',
      requiredApprover: '必填，请选择审批人',
      validate: {
        releaseType: '放行类型不能为空',
        applyCompany: '申请单位不能为空',
        applyPerson: '申请人不能为空',
        idCard: '身份证不能为空',
        phone: '手机号不能为空',
        passTime: '通行时间不能为空',
        itemsRequired: '至少需要一个放行物品',
        itemInfoRequired: '物品名称和数量不能为空',
        approverRequired: '审批人不能为空'
      }
    },
  }
}